import React from 'react';
import { Wrench } from 'lucide-react';

/**
 * Site-wide maintenance screen. Shown when `/api/maintenance` returns
 * `enabled: true`. The admin panel is unaffected and remains reachable at
 * `/admin/config` (bypasses this page).
 */
export default function MaintenancePage({ message }) {
  return (
    <div
      className="min-h-screen bg-[#0F1419] flex items-center justify-center px-6"
      data-testid="maintenance-page"
    >
      <div className="max-w-lg w-full text-center">
        <div className="w-20 h-20 rounded-full bg-[#FFB238]/15 border border-[#FFB238]/40 flex items-center justify-center mx-auto mb-7">
          <Wrench className="w-9 h-9 text-[#FFB238]" />
        </div>
        <h1 className="text-3xl sm:text-4xl font-bold text-white mb-3 tracking-tight">
          We'll be right back.
        </h1>
        <p
          className="text-base text-gray-400 leading-relaxed whitespace-pre-line"
          data-testid="maintenance-message"
        >
          {message || "We're performing scheduled maintenance. We'll be back shortly."}
        </p>
        <p className="text-xs text-gray-600 mt-8 uppercase tracking-widest">
          Visual Atmos
        </p>
      </div>
    </div>
  );
}
